import { service } from '@ember/service';
import Component from '@glimmer/component';
import Modal from 'bcl/components/modal';
import filterSort from 'bcl/helpers/filter-sort';
import { on } from '@ember/modifier';
import FeedbackWarning from 'bcl/components/feedback/warning';
import type { Store } from '@warp-drive/core';
import { fn } from '@ember/helper';
import type OrderModel from 'bcl/models/order';
import type StocktakingService from 'bcl/services/stocktaking';
import LocationModel from 'bcl/models/location';

interface ModalStocktakingSignature {
  // The arguments accepted by the component
  Args: {
    shown: boolean;
    toggle: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ModalStocktakingComponent extends Component<ModalStocktakingSignature> {
  @service declare store: Store;
  @service declare stocktaking: StocktakingService;

  get locations() {
    return this.store.peekAll<LocationModel>('location');
  }

  get hasCreatedOrders() {
    const allOrders = this.store.peekAll<OrderModel>('order');
    const createdOrders = allOrders.filter((o) => o.status == 'created');
    return createdOrders.length > 0;
  }
  <template>
    {{#if @shown}}
      {{!-- {{#if true}} --}}

      <Modal @close={{@toggle}} @size="big">
        {{#if this.hasCreatedOrders}}
          <FeedbackWarning @header="Bestehende Bestellung">
            <p>Es besteht eine Bestellung, die noch nicht als bestellt markiert
              ist. Dadurch kann die Berechnung für den Bestand falsch sein.</p>
          </FeedbackWarning>
        {{/if}}
        <h2 class="text-xl font-bold mb-4">Inventur</h2>
        <div class="px-4 sm:px-6 lg:pt-4 lg:pb-8">
          {{#each (filterSort this.locations "active" "name") as |location|}}

            <button
              class="ml-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              type="button"
              {{on "click" (fn this.stocktaking.startWith location.id)}}
              {{on "click" @toggle}}
            >Inventur im {{location.name}} starten</button>
          {{/each}}
        </div>
      </Modal>
    {{/if}}
  </template>
}
